export default {
    flightType:{
        oneway: 1,
        roundtrip: 2
    },
    calendarLimit:{
        min: 2,
        max: 15
    }
}